/* eslint-disable react/jsx-filename-extension */
import React from "react";
import { Link } from "react-router-dom";
import range from "lodash/range";
import styled from "styled-components";

import "./SliderItem.css";
import SliderItemInfoBox from "./SliderItemInfoBox";

import { HDM_INTERN, GESPERRT, NOT_AUTHORIZED } from "../../constants";

export const SliderItemWrapper = styled.div`
  position: relative;
`;

export function SlideItem({ src, contentLocked }) {
  return (
    <div className="slide-item">
      <img
        style={contentLocked ? { filter: "saturate(30%)" } : null}
        className="slide-item-image"
        src={src}
        alt=""
      />
    </div>
  );
}

function handleTileHover(event) {
  const target = event.currentTarget;
  target.style.zIndex = "200000";
  target.childNodes[1].style.zIndex = "10";
}

function handleTileUnhover(event) {
  event.currentTarget.style.boxShadow = "none";
  const kindElement = event.currentTarget.childNodes;
  kindElement[1].childNodes[1].style.visibility = "visible";
  event.currentTarget.style.zIndex = "10";
}

function createTrimmedTitle(data, i, maxLength) {
  let titleLimited;
  if (data[i % data.length].projekt_titel.length > maxLength) {
    const limmi = data[i % data.length].projekt_titel.substring(0, maxLength);
    const splitti = limmi.split(" ");
    let final = "";
    for (let j = 0; j < splitti.length - 1; j += 1) {
      if (j === splitti.length - 2) {
        final += splitti[j];
      } else {
        final = `${final + splitti[j]} `;
      }
    }
    titleLimited = `${final}...`;
  } else {
    titleLimited = data[i % data.length].projekt_titel;
  }
  return titleLimited;
}

export function createImageChildren(
  numOfChildren,
  projektDaten,
  numberOfCards,
  passClickedID,
  userRights,
  listPageCallback,
  isOnListPage
) {
  const data = projektDaten;
  const initialInfoBoxHeight = "13vh";

  try {
    return range(numOfChildren).map((i) => (
      <SliderItemWrapper
        className={
          numberOfCards !== 2 && numberOfCards !== 1
            ? "sl-slider-items-wrapper-large"
            : "sl-slider-items-wrapper-mobile"
        }
        onMouseEnter={
          numberOfCards !== 2 && numberOfCards !== 1
            ? ($event) => handleTileHover($event, i)
            : null
        }
        onMouseLeave={
          numberOfCards !== 2 && numberOfCards !== 1
            ? ($event) => handleTileUnhover($event, i)
            : null
        }
      >
        <Link
          to={`/mediathek/projectpage/${
            data[i % data.length].projekt_ID
          }/details`}
          onClick={() => passClickedID(data[i % data.length].projekt_ID)}
          aria-label={`Projektseite: ${data[i % data.length].projekt_titel}`}
        >
          <SlideItem
            className="sl-slide-item-tile"
            key={i}
            src={`https://www.hdm-stuttgart.de/mediathek/stage_mediafiles/${
              data[i % data.length].projekt_ID
            }/medianight_web/klein.jpg`}
            /* Inhalte werden als gesperrt markiert wenn der Nutzer nicht angemeldet
          ist und rechte_ring 1 oder 0 ist */
            contentLocked={
              Number(userRights) === NOT_AUTHORIZED && // userRights < 1 &&
              (Number(data[i % data.length].rechte_ring) === HDM_INTERN ||
                Number(data[i % data.length].rechte_ring) === GESPERRT)
            }
          />
        </Link>
        <SliderItemInfoBox
          boxHeight={initialInfoBoxHeight}
          title={data ? createTrimmedTitle(data, i, 49) : " "}
          displaycContentLockedMsg={
            Number(userRights) === NOT_AUTHORIZED &&
            (Number(data[i % data.length].rechte_ring) === HDM_INTERN ||
              Number(data[i % data.length].rechte_ring) === GESPERRT)
          }
          projektID={data[i % data.length].projekt_ID}
          semester={
            data ? data[i % data.length].medianight_semester : "Kein Semester"
          }
          imgSrc={`https://www.hdm-stuttgart.de/mediathek/stage_mediafiles/${
            data[i % data.length].projekt_ID
          }/medianight_web/klein.jpg`}
          medienartID={data[i % data.length].projekt_medienart_ID}
          stuproID={data[i % data.length].am_studiotechnik_ID}
          callbackFunction={() => listPageCallback()}
          placedOnListPage={isOnListPage}
          infoBoxCallback={passClickedID}
        />
      </SliderItemWrapper>
    ));
  } catch {
    console.log("Error");
  }
}
